<template>
  <div class="">
    <div class="row">
      <div class="col-md-12 col-sm-8">
        <div class="card card-default widget animated">
          <div class="card-heading">
            <div class="row">
              <div class="col-md-5">
                <form-text label="Search Organizations" name="searchorganizations" v-model="searchQuery"></form-text>
              </div>
              <div class="col-md-2">
                <router-link class="btn btn-success" to="/stanadmin/organization/create">Add</router-link>
              </div>
            </div>
            <br/>
            <data-table :data="orgs" :columns="columns" :filter-key="searchQuery"></data-table>
          </div>
        </div>
      </div><!-- /.col-md-12 -->
      </div><!-- /.col-md-3 -->
    </div>
  </div>
</template>

<script>
import DataTable from './OrganizationsTable'
import FormText from '../../elements/Form/FormText'
import database from '../../webmaster/Database/database'

export default {
  name: 'organizations',
  components: {
    'data-table': DataTable,
    'form-text': FormText
  },
  data () {
    return {
        searchQuery: '',
        columns: ['name', 'description', 'emails', 'chat', 'inventory', 'more'],
        orgs: []
    }
  },
  created:function(){
    //Populate orgs
    this.$bindAsArray('orgs', database.getRef('/meta_orgs'));
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// Organizations.vue?d16fb3fc